// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 895) return "895/895.836adb7ef37d0fbe628f.min.css";
	if (chunkId === 516) return "team/team.f3509466a00949ca5295.min.css";
	// return url for filenames based on template
	return undefined;
};